import React, { useEffect, useState } from 'react'
import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button'
import { icons } from '../../constants'
import storage from '../../services/stoage.service'
import utils from '../../utils'
import './lts-json-editor-dialog.scss'

/**
 * Modal para edição visual de JSON em formato de formulário
 * 
 * @param {Object} props
 * @param {boolean} props.visible - Controla visibilidade do modal
 * @param {Object} props.value - Objeto JSON a ser editado
 * @param {string} props.title - Título do modal
 * @param {string} props.labelConfirmar - Texto do botão confirmar
 * @param {string} props.width - Largura do modal
 * @param {Function} props.onHide - Callback ao fechar modal
 * @param {Function} props.onConfirm - Callback ao confirmar (recebe o objeto editado)
 * @param {Function} props.renderForm - Função que renderiza o formulário customizado
 *                                      Recebe (data, onChange, errors) como parâmetros
 * @param {Function} props.validate - Função de validação customizada
 *                                    Recebe (data) e retorna objeto de erros ou null
 * @returns {JSX.Element}
 */
export default function LtsJsonEditorDialog(props) {
  const {
    visible,
    value,
    title = 'Edição Visual',
    labelConfirmar = 'Confirmar',
    width = '50vw',
    onHide,
    onConfirm,
    renderForm,
    validate,
  } = props

  const messages = storage.getAppLabels('lts')
  const [jsonData, setJsonData] = useState({})
  const [errors, setErrors] = useState({})

  useEffect(() => {
    if (visible) {
      resetValues()
    }
  }, [visible, value])

  const resetValues = () => {
    const data = value && typeof value === 'object' ? value : {}
    setJsonData(data)
    setErrors({})
  }

  const handleHide = () => {
    onHide?.()
  }

  const handleChange = (field, newValue) => {
    const newData = { ...jsonData, [field]: newValue }
    setJsonData(newData)
    
    // Validar em tempo real se houver função de validação
    if (validate) {
      const validationErrors = validate(newData)
      setErrors(validationErrors || {})
    }
  }

  const handleConfirm = () => {
    // Validar antes de confirmar
    if (validate) {
      const validationErrors = validate(jsonData)
      if (validationErrors && Object.keys(validationErrors).length > 0) {
        setErrors(validationErrors)
        return
      }
    }
    
    onConfirm?.(jsonData)
    handleHide()
  }

  const isConfirmarDisabled = () => {
    return errors && Object.keys(errors).length > 0
  }

  const renderFormContent = () => {
    // Se foi passado um renderForm customizado, usa ele
    if (renderForm) {
      return renderForm(jsonData, handleChange, errors)
    }
    
    // Caso contrário, mostra preview do JSON
    return (
      <div className="p-col-12">
        <p>Formulário de edição será implementado aqui</p>
        <pre>{JSON.stringify(jsonData, null, 2)}</pre>
      </div>
    )
  }

  return (
    <Dialog
      header={title}
      visible={visible}
      style={{ width }}
      onHide={handleHide}
      baseZIndex={1000000}
      modal
      closable
    >
      <div style={{ marginTop: '20px' }} className="p-grid p-fluid">
        {renderFormContent()}
      </div>
      <div style={{ marginTop: '20px' }} className="p-grid form-group">
        <div className="p-col-12 p-md-6">
          <Button
            label={utils.getMessage(messages, 'lts.label.jsonarea.modal.button.resetar')}
            onClick={resetValues}
            icon="pi pi-refresh"
            className="p-button-secondary"
          />
        </div>
        <div className="p-col-12 p-md-6">
          <Button
            label={labelConfirmar}
            onClick={handleConfirm}
            disabled={isConfirmarDisabled()}
            icon={icons.CHECK_ICON}
            className="p-button-success"
          />
        </div>
      </div>
    </Dialog>
  )
}
